import { theme } from 'antd';
import { CustomThemeToken } from '@/theme';
import { FC } from 'react';

const { useToken } = theme;

const GDPlatinumGuardIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 89, height = 32, ...rest }) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentThemeColor = token.GDPlatinumColor;

  return (
    <svg width={width} height={height} viewBox="0 0 89 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M35.2895 22.9495V22.913C35.2895 19.3882 37.9869 16.4026 41.7813 16.4026C43.9752 16.4026 45.3234 17.0142 46.6183 18.1115L45.2154 19.784C44.2445 18.9564 43.2917 18.4351 41.6911 18.4351C39.3716 18.4351 37.6092 20.4674 37.6092 22.8771V22.913C37.6092 25.5033 39.3174 27.4096 41.8889 27.4096C43.0758 27.4096 44.1547 27.0318 44.9279 26.4564V24.1005H41.7093V22.1757H47.068V27.4634C45.8273 28.5247 44.0467 29.424 41.8169 29.424C37.8791 29.424 35.2895 26.6184 35.2895 22.9495Z"
        fill="#D01C2E"
      />
      <path
        d="M48.8672 25.755V19.7121H51.0433V25.1075C51.0433 26.582 51.7805 27.4096 53.0754 27.4096C54.3338 27.4096 55.215 26.5462 55.215 25.0715V19.7121H57.4089V29.2082H55.215V27.733C54.6036 28.6323 53.7224 29.4061 52.248 29.4061C50.1083 29.4061 48.8672 27.9669 48.8672 25.755Z"
        fill="#D01C2E"
      />
      <path
        d="M65.2862 25.791V25.1434C64.7285 24.9274 63.9913 24.7655 63.1283 24.7655C61.7255 24.7655 60.8985 25.3592 60.8985 26.3483V26.3841C60.8985 27.3014 61.7077 27.8233 62.7506 27.8233C64.189 27.8233 65.2862 26.9958 65.2862 25.791ZM58.7766 26.4745V26.4385C58.7766 24.3882 60.3768 23.3805 62.6964 23.3805C63.7576 23.3805 64.513 23.5427 65.2502 23.7764V23.5427C65.2502 22.1937 64.4228 21.4745 62.8946 21.4745C61.8334 21.4745 61.0425 21.7082 60.1795 22.0681L59.6041 20.3592C60.647 19.8917 61.6717 19.5861 63.1821 19.5861C64.6028 19.5861 65.6635 19.9639 66.3291 20.6474C67.0303 21.3309 67.3538 22.3379 67.3538 23.5785V29.2082H65.2324V28.0212C64.585 28.7945 63.5958 29.4061 62.1392 29.4061C60.359 29.4061 58.7766 28.3805 58.7766 26.4745Z"
        fill="#D01C2E"
      />
      <path
        d="M69.2433 19.7121H71.4189V21.8523C72.0126 20.4316 73.1093 19.4599 74.7815 19.5323V21.8344H74.6557C72.7494 21.8344 71.4189 23.075 71.4189 25.5931V29.2082H69.2433V19.7121Z"
        fill="#D01C2E"
      />
      <path
        d="M82.8738 24.478V24.442C82.8738 22.6075 81.5794 21.4026 80.1228 21.4026C78.6306 21.4026 77.3894 22.5537 77.3894 24.442V24.478C77.3894 26.3123 78.6483 27.5172 80.1228 27.5172C81.5794 27.5172 82.8738 26.2945 82.8738 24.478ZM75.196 24.478V24.442C75.196 21.2945 77.3357 19.5142 79.6015 19.5142C81.1661 19.5142 82.1549 20.2875 82.8383 21.1868V16.0792H85.0139V29.2082H82.8383V27.6253C82.1366 28.6144 81.1475 29.4061 79.6015 29.4061C77.3717 29.4061 75.196 27.6253 75.196 24.478Z"
        fill="#D01C2E"
      />
      <path
        d="M39.0267 9.69374C39.7607 9.69374 40.2187 9.28281 40.2187 8.70646V8.69081C40.2187 8.04375 39.7529 7.70419 39.0267 7.70419H37.8982V9.69374H39.0267ZM36.9272 6.81979H39.1057C40.4001 6.81979 41.205 7.55419 41.205 8.66703V8.68334C41.205 9.92223 40.2105 10.5698 38.9952 10.5698H37.8982V12.3458H36.9272V6.81979Z"
        fill={currentThemeColor}
      />
      <path d="M43.2673 6.81979H44.2382V11.4617H47.1426V12.3458H43.2673V6.81979Z" fill={currentThemeColor} />
      <path
        d="M52.0933 10.1514L51.1384 7.94081L50.191 10.1514H52.0933ZM50.7042 6.78054H51.6041L54.0348 12.3458H53.0087L52.4484 11.0115H49.8359L49.2676 12.3458H48.2731L50.7042 6.78054Z"
        fill={currentThemeColor}
      />
      <path
        d="M56.697 7.71979H54.9448V6.81979H59.4276V7.71979H57.6759V12.3458H56.697V7.71979Z"
        fill={currentThemeColor}
      />
      <path d="M61.5766 6.81979H62.5475V12.3458H61.5766V6.81979Z" fill={currentThemeColor} />
      <path
        d="M65.0902 6.81979H65.9901L68.95 10.6405V6.81979H69.905V12.3458H69.0918L66.0452 8.41476V12.3458H65.0902V6.81979Z"
        fill={currentThemeColor}
      />
      <path
        d="M72.3068 10.001V6.81977H73.2777V9.96164C73.2777 10.9882 73.8065 11.5328 74.6744 11.5328C75.5347 11.5328 76.0635 11.0194 76.0635 10.001V6.81977H77.0344V9.95417C77.0344 11.604 76.103 12.4326 74.6588 12.4326C73.2222 12.4326 72.3068 11.604 72.3068 10.001Z"
        fill={currentThemeColor}
      />
      <path
        d="M79.4362 6.81979H80.4703L82.1513 9.43263L83.8324 6.81979H84.8664V12.3458H83.8955V8.38299L82.1513 10.9882H82.1198L80.3912 8.39863V12.3458H79.4362V6.81979Z"
        fill={currentThemeColor}
      />
      <path
        d="M25.8102 8.58489C25.8102 10.454 25.6425 13.3292 24.8482 16.4097C23.96 19.8538 22.5156 22.7877 20.5558 25.1288C18.7971 27.2287 16.5734 28.9071 13.9445 30.1174L13.7249 30.2182L13.5053 30.1174C10.8761 28.9071 8.65231 27.2287 6.89376 25.1288C4.93405 22.7877 3.48968 19.8538 2.60143 16.4097C1.80712 13.3285 1.63946 10.454 1.63946 8.58489V8.1736L2.03833 8.07449C5.61012 7.18662 8.75993 5.47169 10.7735 4.18924C11.6754 3.61511 12.5612 2.99755 13.4064 2.35467L13.7249 2.11213L14.0434 2.35467C14.8884 2.99755 15.7742 3.61511 16.6761 4.18924C18.6895 5.47169 21.8395 7.18662 25.4113 8.07449L25.8102 8.1736V8.58489ZM27.3993 6.81111C23.4842 6.17658 19.9195 4.31111 17.5563 2.80644C15.8087 1.69342 14.4739 0.632977 13.7249 0C12.9757 0.632977 11.6409 1.69342 9.89325 2.80644C7.53028 4.31111 3.96529 6.17658 0.0503195 6.81111C-0.0461929 8.42169 -0.12274 12.4097 1.01423 16.8191C2.9224 24.2194 7.19753 29.3248 13.7249 32C20.2522 29.3248 24.5272 24.2194 26.4356 16.8191C27.5724 12.4104 27.4958 8.42222 27.3993 6.81111Z"
        fill={currentThemeColor}
      />
      <path
        d="M13.7249 3.28926L13.0063 3.8021C12.4395 4.20659 11.8561 4.60001 11.2719 4.97206C9.49469 6.10419 6.69833 7.65975 3.47021 8.64117L2.5549 8.91944L2.59378 9.87552C2.68355 12.0731 2.98834 14.1934 3.49972 16.1778C4.35339 19.4873 5.73458 22.2983 7.60511 24.5328C9.10831 26.3276 10.9778 27.8037 13.162 28.9194L13.7249 29.2071V3.28926Z"
        fill="#A91A2D"
      />
      <path
        d="M13.7249 3.28926L14.4434 3.8021C15.0101 4.20659 15.5935 4.60001 16.1778 4.97206C17.9549 6.10419 20.7513 7.65975 23.9792 8.64117L24.8947 8.91944L24.8558 9.87552C24.7661 12.0731 24.4613 14.1934 23.9497 16.1778C23.0962 19.4873 21.715 22.2983 19.8445 24.5328C18.3413 26.3276 16.4716 27.8037 14.2877 28.9194L13.7249 29.2071V3.28926Z"
        fill="#D01C2E"
      />
      <path d="M86.0005 28.2129H85.621V27.9599H86.6541V28.2129H86.2746V29.2069H86.0005V28.2129Z" fill="#D01C2E" />
      <path
        d="M86.8616 27.9599H87.1576L87.4851 28.4872L87.813 27.9599H88.1085V29.2069H87.8361V28.3929L87.4851 28.9257H87.4779L87.1309 28.3986V29.2069H86.8616V27.9599Z"
        fill="#D01C2E"
      />
    </svg>
  );
};

export default GDPlatinumGuardIcon;
